import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AppContext } from '../AppContext';
import { useProjectId } from '../useProjectId'; // Supondo que o hook useProjectId seja utilizado para obter o projectId

const steps = [
  { path: "/", label: "Início" },
  { path: "/tipo", label: "Tipo" },
  { path: "/titulo", label: "Título" },
  { path: "/logo", label: "Logotipo" },
  { path: "/cores", label: "Cores" },
  { path: "/inicial", label: "Tela Inicial" },
  { path: "/nav", label: "Navegação" },
  { path: "/mais", label: "Mais" },
  { path: "#", label: "Finalizar" },
];

const Header: React.FC = () => {
  const context = useContext(AppContext); // Use o contexto

  // Verifica se o contexto está definido
  if (!context) {
    throw new Error('Step2 must be used within an AppProvider');
  }

  const { appData, updateAppData } = context;
  const projectId = useProjectId(); // Obtendo o projectId
  const location = useLocation();

  const currentIndex = steps.findIndex(step => step.path === location.pathname.replace(`/${projectId}`, ''));

  return (
    <div className="header bg-primary">
      <nav>
        <div className="top mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-32 items-center justify-between">
            <div className="flex items-center">
              <div className="zasmedia">
                <img src="https://build.zas.media/images/logotipo.png" alt="Zasmedia" />
              </div>
            </div>
            <ul className="steps">
              {steps.map((step, index) => (
                <li
                  key={step.path}
                  className={`step ${index < currentIndex ? "complete" : ""} ${index === currentIndex ? "step-primary" : ""}`}
                >
                  {index <= currentIndex ? (
                    <Link to={`/${projectId}${step.path}`}>{step.label}</Link>
                  ) : (
                    <span>{step.label}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </nav>
      <header className="shadow-sm">
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
          <h1 className="text-3xl font-bold tracking-tight text-white">Personalizador de App</h1>
        </div>
      </header>
    </div>
  );
};

export default Header;
